/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as e, isSome as t, unwrapOr as n } from "../core/maybe.js";
import { getMetersPerUnit as o } from "../symbols/support/unitConversionUtils.js";

function r(t, n) {
  return e(n) || !n.mode ? t ? "absolute-height" : "on-the-ground" : n.mode;
}

function i(e, n) {
  return r(!!t(e) && e.hasZ, n);
}

function u(e) {
  var t = l(e);
  return i(e.geometry, t);
}

function s(e) {
  var r = l(e),
      u = i(e.geometry, r);
  return {
    mode: u,
    offset: t(r) && "on-the-ground" !== u ? n(r.offset, 0) * o(n(r.unit, "meters")) : 0
  };
}

function a(e) {
  if ("on-the-ground" === u(e)) return !1;
  var n = l(e),
      o = t(n) && n.featureExpressionInfo ? n.featureExpressionInfo.expression : null;
  return !(!o || "0" === o);
}

function l(e) {
  return e.layer && "elevationInfo" in e.layer ? e.layer.elevationInfo : null;
}

function c(o, r, i) {
  if (e(i) || !i.mode) return;
  var u = o.hasZ ? o.z : 0,
      s = t(i.offset) ? i.offset : 0;

  switch (i.mode) {
    case "absolute-height":
      return u - s;

    case "on-the-ground":
      return 0;

    case "relative-to-ground":
      return u - (n(r.elevationProvider.getElevation(o.x, o.y, o.z, o.spatialReference, "ground"), 0) + s);

    case "relative-to-scene":
      return u - (n(r.elevationProvider.getElevation(o.x, o.y, o.z, o.spatialReference, "scene"), 0) + s);
  }
}

function f(e, t, n) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return g(e, t.x, t.y, t.hasZ ? t.z : 0, t.spatialReference, n, o);
}

function v(e, t, n, o) {
  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return g(e, t[0], t[1], t.length > 2 ? t[2] : 0, n, o, r);
}

function g(n, o, r, i, u, s) {
  var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  if (e(s)) return;
  var l = t(a) ? a.mode : "absolute-height";
  if ("on-the-ground" === l) return 0;
  return h(d(o, r, i, u, n, s), o, r, i, u, n, a, l);
}

function d(e, o, r, i, u, s) {
  var a = t(s.offset) ? s.offset : 0;

  switch (s.mode) {
    case "absolute-height":
      return r + a;

    case "on-the-ground":
      return n(u.elevationProvider.getElevation(e, o, 0, i, "ground"), 0);

    case "relative-to-ground":
      return r + n(u.elevationProvider.getElevation(e, o, r, i, "ground"), 0) + a;

    case "relative-to-scene":
      return r + n(u.elevationProvider.getElevation(e, o, r, i, "scene"), 0) + a;
  }
}

function h(e, o, r, i, u, s, a, l) {
  var c = t(a) && t(a.offset) ? a.offset : 0;

  switch (l) {
    case "absolute-height":
      return e - c;

    case "relative-to-ground":
      return e - (n(s.elevationProvider.getElevation(o, r, i, u, "ground"), 0) + c);

    case "relative-to-scene":
      return e - (n(s.elevationProvider.getElevation(o, r, i, u, "scene"), 0) + c);
  }
}

export { f as getConvertedElevation, v as getConvertedElevationFromVector, r as getEffectiveElevationMode, i as getGeometryEffectiveElevationMode, s as getGraphicEffectiveElevationInfo, u as getGraphicEffectiveElevationMode, c as getZForElevationMode, a as hasGraphicFeatureExpressionInfo, d as zValueInAbsoluteHeightMode };